import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { GapDistribution } from "@/components/grc/GapDistribution";
import { SDFDualModule } from "@/components/grc/SDFDualModule";
import { RemediationFunnel } from "@/components/grc/RemediationFunnel";

export const RoPACoverageTile = ({ assessmentId }) => {
  const [summary, setSummary] = useState(null);
  useEffect(() => {
    api.get(`/ropa/${assessmentId}/summary`).then(({ data }) => setSummary(data)).catch(() => {});
  }, [assessmentId]);
  if (!summary) return null;
  const pct = summary.ropa_coverage_pct ?? 0;
  const colour = pct >= 85 ? "#388E3C" : pct >= 60 ? "#FBC02D" : pct >= 40 ? "#F57C00" : "#D32F2F";
  return (
    <Link
      to={`/assessment/${assessmentId}/ropa`}
      data-testid="zone-c-ropa-tile"
      className="block bg-white border border-slate-200 rounded-xl p-5 hover:border-[#008080] transition-colors"
    >
      <div className="text-[11px] uppercase tracking-wide text-slate-400 font-semibold">RoPA Coverage</div>
      <div className="mt-2 flex items-baseline gap-2">
        <span className="text-3xl font-bold" style={{ color: colour }} data-testid="zone-c-ropa-coverage">{pct}%</span>
        <span className="text-xs text-slate-500">{summary.approved} approved record(s)</span>
      </div>
      <div className="mt-1 text-xs" style={{ color: summary.open_conflicts > 0 ? "#D32F2F" : "#64748B" }}
        data-testid="zone-c-ropa-conflicts">
        {summary.open_conflicts} open conflict(s) · view register →
      </div>
    </Link>
  );
};

export const ZoneC = ({ data, assessmentId }) => {
  const zc = data?.zone_c;
  if (!zc) return null;
  return (
    <section data-testid="zone-c" className="space-y-3">
      <h2 className="text-base md:text-lg font-semibold text-[#008080]">Zone C — Gap & SDF Intelligence</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-1 gap-4">
        <GapDistribution data={zc.gap_distribution} />
        <SDFDualModule data={zc.sdf_detail} />
        <RemediationFunnel data={zc.remediation_funnel} deadline={data.compliance_deadline} />
        {assessmentId && <RoPACoverageTile assessmentId={assessmentId} />}
      </div>
    </section>
  );
};
